import styled from 'styled-components';

export const Container = styled('div')`
    color: ${(props) => props.theme.colors.cardSettingsTextColor};
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    width: 100%;

    .icon {
      fill: ${(props) => props.theme.cardAnnotationsMenu.iconColor};
      margin-right: 13px;
      margin-top: 5px;
    }
    .icondown{
      fill: ${(props) => props.theme.cardAnnotationsMenu.iconDownColor};
    }

`;

export const Label = styled.div`
  width: auto;
`;

export const Action = styled.div`
`;
